<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('refund', 1) }} {{ $tc('reason', 1) }}</div>
      <router-link
        class="btn-blue"
        to="refund-reasons"
      >{{ $tc('refund', 1) }} {{ $tc('reason', 1) }} List</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in RefundReasons"
          :key="index"
          v-if="item.fieldname !== 'rr_id'"
          class="col-lg-4 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'rr_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <!-- @focus="onFocusHandler" -->
                <!-- :required="item.required" -->
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1)}}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has(item.fieldname)"
              >{{ errors.first(`${item.fieldname}`) }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'rr_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t('active') }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button class="btn-blue" @click.prevent.stop="handleSubmit(true)">{{ $t('save') }}</button>
          <button
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="refund-reasons"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import RefundReasons from "@/helper/formJSONMaster/RefundReasons";

export default {
  data() {
    return {
      RefundReasons: RefundReasons.ms_refund_reasons,
      // v-validate="'required|email'"
      submitted: false,
      Methods: RefundReasons.Methods
    };
  },
  mounted() {
    console.log("RefundReasons :", RefundReasons);
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    resetHandler: function() {
      this.RefundReasons.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(redirect) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          console.log("valid :", valid);
          let body = this.getRequestBody(
            "POST",
            this.RefundReasons,
            this.Methods
          );
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then(response => {
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (redirect) {
                  this.$router.push({
                    path: "/master/refund-reasons"
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/RefundReasonComponents/addRefundReason.vue